var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { CurrentOrderService } from './../order/currentOrder.service';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { FlagService } from '../modules/features/flag.service';
import { AuthService } from '../modules/auth/auth.service';
import { Router } from '@angular/router';
var ConnexionComponent = (function () {
    function ConnexionComponent(titleService, translate, flag, auth, route, currentOrderService) {
        this.titleService = titleService;
        this.translate = translate;
        this.flag = flag;
        this.auth = auth;
        this.route = route;
        this.currentOrderService = currentOrderService;
        this.currentYear = "";
        this.isAuth0FlagActivate = this.flag.isAuth0LoginActive();
        this.isPromoActive = this.flag.isPromoActive();
        if (this.auth.loggedIn && this.isAuth0FlagActivate)
            this.route.navigate(['/dashboard']);
        this.titleService.setTitle("Connexion | Uptime");
        this.lang = this.translate.currentLang;
        this.currentYear = new Date().getFullYear().toString();
    }
    ConnexionComponent.prototype.changeLang = function (lang) {
        if (this.translate.currentLang != lang) {
            //void(window.$zopim.livechat.removeTags("lan_"+this.translate.currentLang));
            try {
                void (window.$zopim.livechat.removeTags("lan_fr", "lan_en", "lan_de", "lan_pt", "lan_es", "lan_it", "lan_nl"));
                void (window.$zopim.livechat.addTags("lan_" + this.translate.currentLang));
            }
            catch (error) {
                console.error(error);
            }
            localStorage.setItem("preferedLanguage", lang);
            this.translate.use(lang);
            this.translate.currentLang = lang;
            this.lang = lang;
            console.log("lan_" + this.translate.currentLang);
        }
        void (window.$zopim.livechat.setLanguage(lang));
    };
    ConnexionComponent.prototype.startOrder = function () {
        this.currentOrderService.resetAll();
    };
    ConnexionComponent = __decorate([
        Component({
            selector: 'cx-connexion',
            templateUrl: './connexion.component.html',
        }),
        __metadata("design:paramtypes", [Title,
            TranslateService,
            FlagService,
            AuthService,
            Router,
            CurrentOrderService])
    ], ConnexionComponent);
    return ConnexionComponent;
}());
export { ConnexionComponent };
//# sourceMappingURL=connexion.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/connexion/connexion.component.js
// module id = 591
// module chunks = 0